/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigChangeConfigResponse,
  ConfigChangeListResponse,
  CustomerConfigResponse,
  CustomerConfigUpdateRequest,
  ErrorResponse,
  PlayerDataCustomerConfig,
} from '../models/index';
import {
    ConfigChangeConfigResponseFromJSON,
    ConfigChangeConfigResponseToJSON,
    ConfigChangeListResponseFromJSON,
    ConfigChangeListResponseToJSON,
    CustomerConfigResponseFromJSON,
    CustomerConfigResponseToJSON,
    CustomerConfigUpdateRequestFromJSON,
    CustomerConfigUpdateRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PlayerDataCustomerConfigFromJSON,
    PlayerDataCustomerConfigToJSON,
} from '../models/index';

export interface GetCustomerConfigRequest {
    customerId: string;
    xRequestID?: string;
}

export interface GetCustomerConfigVersionRequest {
    changeId: string;
    customerId: string;
    xRequestID?: string;
}

export interface GetPlayerDataConfigRequest {
    customerId: string;
    xRequestID?: string;
}

export interface GetPlayerDataConfigVersionRequest {
    changeId: string;
    customerId: string;
    xRequestID?: string;
}

export interface ListCustomerConfigHistoryRequest {
    customerId: string;
    xRequestID?: string;
}

export interface ListPlayerDataConfigHistoryRequest {
    customerId: string;
    xRequestID?: string;
}

export interface PatchCustomerConfigRequest {
    customerId: string;
    customerConfigUpdateRequest: CustomerConfigUpdateRequest;
    xRequestID?: string;
}

export interface PatchPlayerDataConfigRequest {
    customerId: string;
    playerDataCustomerConfig: PlayerDataCustomerConfig;
    xRequestID?: string;
}

export interface RestoreCustomerConfigVersionRequest {
    changeId: string;
    customerId: string;
    xRequestID?: string;
}

export interface RestorePlayerDataConfigVersionRequest {
    changeId: string;
    customerId: string;
    xRequestID?: string;
}

/**
 * 
 */
export class CustomersApi extends runtime.BaseAPI {

    /**
     */
    async getCustomerConfigRaw(requestParameters: GetCustomerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerConfigResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerConfigResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerConfig(requestParameters: GetCustomerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerConfigResponse> {
        const response = await this.getCustomerConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets one saved version of the customer\'s back office config
     */
    async getCustomerConfigVersionRaw(requestParameters: GetCustomerConfigVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigChangeConfigResponse>> {
        if (requestParameters['changeId'] == null) {
            throw new runtime.RequiredError(
                'changeId',
                'Required parameter "changeId" was null or undefined when calling getCustomerConfigVersion().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerConfigVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/config/history/{changeId}`;
        urlPath = urlPath.replace(`{${"changeId"}}`, encodeURIComponent(String(requestParameters['changeId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigChangeConfigResponseFromJSON(jsonValue));
    }

    /**
     * Gets one saved version of the customer\'s back office config
     */
    async getCustomerConfigVersion(requestParameters: GetCustomerConfigVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigChangeConfigResponse> {
        const response = await this.getCustomerConfigVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPlayerDataConfigRaw(requestParameters: GetPlayerDataConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerDataCustomerConfig>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPlayerDataConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/player-data-config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerDataCustomerConfigFromJSON(jsonValue));
    }

    /**
     */
    async getPlayerDataConfig(requestParameters: GetPlayerDataConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerDataCustomerConfig> {
        const response = await this.getPlayerDataConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets one saved version of the customer\'s player data config
     */
    async getPlayerDataConfigVersionRaw(requestParameters: GetPlayerDataConfigVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigChangeConfigResponse>> {
        if (requestParameters['changeId'] == null) {
            throw new runtime.RequiredError(
                'changeId',
                'Required parameter "changeId" was null or undefined when calling getPlayerDataConfigVersion().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPlayerDataConfigVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/player-data-config/history/{changeId}`;
        urlPath = urlPath.replace(`{${"changeId"}}`, encodeURIComponent(String(requestParameters['changeId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigChangeConfigResponseFromJSON(jsonValue));
    }

    /**
     * Gets one saved version of the customer\'s player data config
     */
    async getPlayerDataConfigVersion(requestParameters: GetPlayerDataConfigVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigChangeConfigResponse> {
        const response = await this.getPlayerDataConfigVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists every saved version of the customer\'s back office config, newest first
     */
    async listCustomerConfigHistoryRaw(requestParameters: ListCustomerConfigHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigChangeListResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listCustomerConfigHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/config/history`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigChangeListResponseFromJSON(jsonValue));
    }

    /**
     * Lists every saved version of the customer\'s back office config, newest first
     */
    async listCustomerConfigHistory(requestParameters: ListCustomerConfigHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigChangeListResponse> {
        const response = await this.listCustomerConfigHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists every saved version of the customer\'s player data config, newest first
     */
    async listPlayerDataConfigHistoryRaw(requestParameters: ListPlayerDataConfigHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigChangeListResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listPlayerDataConfigHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/player-data-config/history`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigChangeListResponseFromJSON(jsonValue));
    }

    /**
     * Lists every saved version of the customer\'s player data config, newest first
     */
    async listPlayerDataConfigHistory(requestParameters: ListPlayerDataConfigHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigChangeListResponse> {
        const response = await this.listPlayerDataConfigHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async patchCustomerConfigRaw(requestParameters: PatchCustomerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerConfigResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling patchCustomerConfig().'
            );
        }

        if (requestParameters['customerConfigUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'customerConfigUpdateRequest',
                'Required parameter "customerConfigUpdateRequest" was null or undefined when calling patchCustomerConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerConfigUpdateRequestToJSON(requestParameters['customerConfigUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerConfigResponseFromJSON(jsonValue));
    }

    /**
     */
    async patchCustomerConfig(requestParameters: PatchCustomerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerConfigResponse> {
        const response = await this.patchCustomerConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async patchPlayerDataConfigRaw(requestParameters: PatchPlayerDataConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerDataCustomerConfig>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling patchPlayerDataConfig().'
            );
        }

        if (requestParameters['playerDataCustomerConfig'] == null) {
            throw new runtime.RequiredError(
                'playerDataCustomerConfig',
                'Required parameter "playerDataCustomerConfig" was null or undefined when calling patchPlayerDataConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/player-data-config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlayerDataCustomerConfigToJSON(requestParameters['playerDataCustomerConfig']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerDataCustomerConfigFromJSON(jsonValue));
    }

    /**
     */
    async patchPlayerDataConfig(requestParameters: PatchPlayerDataConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerDataCustomerConfig> {
        const response = await this.patchPlayerDataConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replaces the customer\'s back office config with an earlier version. The restore is saved as a new version.
     */
    async restoreCustomerConfigVersionRaw(requestParameters: RestoreCustomerConfigVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerConfigResponse>> {
        if (requestParameters['changeId'] == null) {
            throw new runtime.RequiredError(
                'changeId',
                'Required parameter "changeId" was null or undefined when calling restoreCustomerConfigVersion().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling restoreCustomerConfigVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/config/history/{changeId}/restore`;
        urlPath = urlPath.replace(`{${"changeId"}}`, encodeURIComponent(String(requestParameters['changeId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerConfigResponseFromJSON(jsonValue));
    }

    /**
     * Replaces the customer\'s back office config with an earlier version. The restore is saved as a new version.
     */
    async restoreCustomerConfigVersion(requestParameters: RestoreCustomerConfigVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerConfigResponse> {
        const response = await this.restoreCustomerConfigVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replaces the customer\'s player data config with an earlier version. The restore is saved as a new version.
     */
    async restorePlayerDataConfigVersionRaw(requestParameters: RestorePlayerDataConfigVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerDataCustomerConfig>> {
        if (requestParameters['changeId'] == null) {
            throw new runtime.RequiredError(
                'changeId',
                'Required parameter "changeId" was null or undefined when calling restorePlayerDataConfigVersion().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling restorePlayerDataConfigVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/player-data-config/history/{changeId}/restore`;
        urlPath = urlPath.replace(`{${"changeId"}}`, encodeURIComponent(String(requestParameters['changeId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerDataCustomerConfigFromJSON(jsonValue));
    }

    /**
     * Replaces the customer\'s player data config with an earlier version. The restore is saved as a new version.
     */
    async restorePlayerDataConfigVersion(requestParameters: RestorePlayerDataConfigVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerDataCustomerConfig> {
        const response = await this.restorePlayerDataConfigVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
